import _regeneratorRuntime from "@babel/runtime-corejs2/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "@babel/runtime-corejs2/helpers/esm/asyncToGenerator";
import { dapiFetchCache } from '@origin-digital/daxi';
var REQUEST_CACHE_TTL_IN_MIN = 30;

var fetchAppContext = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(xhrHost) {
    var options, response;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            options = {
              authorization: 'raw',
              host: xhrHost,
              method: 'GET',
              ttlInMin: REQUEST_CACHE_TTL_IN_MIN
            };
            _context.next = 3;
            return dapiFetchCache('/api/appcontext/v1/sac', options);

          case 3:
            response = _context.sent;
            return _context.abrupt("return", response.data);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchAppContext(_x) {
    return _ref.apply(this, arguments);
  };
}();

var fetchAppContextV2 = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(xhrHost) {
    var options, response;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            options = {
              authorization: 'jwt',
              host: xhrHost,
              method: 'GET',
              ttlInMin: REQUEST_CACHE_TTL_IN_MIN
            };
            _context2.next = 3;
            return dapiFetchCache('/api/appcontext/v2/sac', options);

          case 3:
            response = _context2.sent;
            return _context2.abrupt("return", response.data);

          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function fetchAppContextV2(_x2) {
    return _ref2.apply(this, arguments);
  };
}();

export { fetchAppContext, fetchAppContextV2 };